<template>
  <div class="good-info-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="base-info group">
          <div class="basic">
            <!-- <span>*</span> -->
            基本信息
          </div>
          <el-form
            ref="form"
            :rules="rules"
            :model="baseInfo"
            class="good-form base-info-form"
            label-width="auto"
          >
            <el-form-item label="样品名称" prop="name" class="form-item">
              <el-input
                placeholder="请输入样品名称"
                v-model="baseInfo.name"
                class="good-input"
              ></el-input>
              <!-- <span class="tip">样品名称不要超过一百个字</span> -->
            </el-form-item>
            <el-form-item label="样品图片" class="form-item" prop="masterPic">
              <p class="tips" style="margin-bottom: 8px">
                建议尺寸：600*600，图片类型jpg、png
              </p>
              <div class="img-box">
                <imgUpLoader
                  :max-pic-num="1"
                  @getPics="getMasterImgList"
                  :index="0"
                  text="主图"
                  :imgUrl="baseInfo.masterPic"
                />
                <!-- <upLoader
                  v-for="(item, index) in bannerNum"
                  :key="index"
                  :max-pic-num="1"
                  @getPics="getImgList"
                  :index="index"
                  text="细节图"
                  :imgUrl="baseInfo.slideshow[index]"
                /> -->
              </div>
            </el-form-item>
            <el-form-item label="运费模版" prop="freight" class="form-item">
              <el-select
                placeholder="请选择"
                filterable
                v-model="baseInfo.freight"
                class="good-input"
                style="width: 185px"
              >
                <el-option
                  v-for="item in freightList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status" class="form-item">
              <el-radio-group v-model="baseInfo.status">
                <el-radio :label="3">出售中</el-radio>
                <el-radio :label="1">仓库中</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="关联产品" prop="slogan" class="form-item">
              <div class="add-goods-box">
                <div class="left">
                  <!-- <div class="item" v-for="(item, index) in goodsList" :key="item.id">
                {{ item.id }}
                <span v-if="index !== goodsList.length - 1">、</span>
                </div> -->
                  <div
                    class="item"
                    v-for="(item, index) in prdList"
                    :key="index"
                  >
                    {{ item.name }}
                    <!-- <div
                      class="iconfont icon-shanchu"
                      @click="deleteGoodSelected(index)"
                    ></div> -->
                  </div>
                  <div class="btn" @click="selectProductModal">
                    + 添加关联产品
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="限购间隔时长"
              prop="limitDays"
              class="form-item"
            >
              <el-input
                placeholder="请输入"
                v-model="baseInfo.limitDays"
                class="good-input"
                style="width: 185px"
              >
                <template slot="append"
                  >天</template
                >
              </el-input>
              <span class="tip">输入0表示无限制时长</span>
            </el-form-item>
            <el-form-item label="限购个数" prop="limitNum" class="form-item">
              <el-input
                placeholder="请输入"
                v-model="baseInfo.limitNum"
                class="good-input"
                style="width: 185px"
              >
                <template slot="append"
                  >个</template
                >
              </el-input>
              <span class="tip">输入0表示无限制个数</span>
            </el-form-item>
            <el-form-item label="销量" prop="baseSales" class="form-item">
              <el-input
                placeholder="请输入"
                v-model="baseInfo.baseSales"
                class="good-input"
                style="width: 185px"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="good-specs-box group">
          <div class="basic">
            <!-- <span>*</span> -->
            售卖信息
          </div>
          <div class="specs good-specs">
            <goods-attr
              :attrSku="key"
              :skuTable="attribute"
              :sales="baseInfo.linePrice"
              @editAttr="editAttr"
              @getSales="getSales"
            />
          </div>
          <div class="specs good-specs-des"></div>
        </div>
        <div class="btn-box">
          <!-- <div class="btn-tip">
            点击“保存并创建商品”按钮后提醒：**内容不能为空！
          </div> -->
          <button class="cancel-btn" @click="handleCancel">取消</button>
          <button class="confirm-btn" @click="handleConfirm">保存</button>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="selectProductVisible"
      class="dialog"
      width="1150px"
      top="10vh"
    >
      <div slot="title" class="dialog-title">
        多选产品
      </div>
      <div class="select-product-box">
        <div class="filter-box">
          <div class="label" style="margin-left: 0;">产品ID：</div>
          <el-input
            v-model="productForm.id"
            placeholder="产品ID"
            style="width: 120px;"
            size="small"
          ></el-input>
          <div class="label">关键字：</div>
          <el-input
            v-model="productForm.name"
            placeholder="关键字"
            style="width: 200px;"
            size="small"
          ></el-input>
          <!-- <div class="label">价格：</div>
          <el-input
            v-model="productForm.minPrice"
            placeholder=""
            style="width: 80px;"
            size="small"
          ></el-input>
          <div style="margin: 0 5px;">至</div>
          <el-input
            v-model="productForm.maxPrice"
            placeholder=""
            style="width: 80px;"
            size="small"
          ></el-input> -->
          <div style="margin: 0 5px;">元</div>
          <div class="search" @click="getGoodsList">搜索</div>
          <div class="reset" @click="resetProduct">重置</div>
        </div>
        <div class="product-list-box">
          <div class="list-left">
            <div class="list-top">
              <el-checkbox
                v-model="selectAll"
                style="margin-right: 6px;"
                @change="handleChangeAll"
              ></el-checkbox>
              选中当前页
            </div>
            <div class="product-list" :key="timeStemp">
              <div
                class="item"
                v-for="(item, index) in productList"
                :key="index"
              >
                <el-checkbox
                  :value="selectedObj[item.id]"
                  @change="(e) => changeSelected(e, item)"
                ></el-checkbox>
                <img :src="item.masterPic" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.name }}</div>
                  <div class="id">产品ID：{{ item.id }}</div>
                </div>
                <div class="price">￥{{ item.price }}</div>
              </div>
            </div>
            <div class="pagination" v-show="productList.length">
              <el-pagination
                @current-change="handleCurrentChangeProduct"
                :current-page.sync="currentPage"
                background
                layout="total, prev, pager, next, jumper"
                :page-size="size"
                :total="total"
                small
              ></el-pagination>
            </div>
          </div>
          <div style="width: 40px;text-align: center;color: #999;">>></div>
          <div class="list-right">
            <div class="list-top">
              已选择产品（{{ selectProductList.length }}）
              <span @click="emptyProduct">清空</span>
            </div>
            <div class="product-list">
              <div
                class="item"
                v-for="(item, index) in selectProductList"
                :key="index"
              >
                {{ index + 1 }}
                <img :src="item.masterPic" alt="" class="pic" />
                <div class="product-info">
                  <div class="name">{{ item.name }}</div>
                  <div class="id">产品ID：{{ item.id }}</div>
                </div>
                <div class="price">￥{{ item.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="selectProductVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addProduct">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import GoodsAttr from '../../components/goods/goodsAttr';
import imgUpLoader from '../../components/goods/imgUpLoader';
import upLoader from '../../components/goods/upLoader';
import UpImgDetail from '../../components/goods/upImgDetail';
import Header from '../../components/common/header';
export default {
  components: { GoodsAttr, imgUpLoader, upLoader, UpImgDetail, Header },
  name: 'goods-lock',
  data() {
    return {
      loading: 0,
      currentPage: 1, // 当前页码
      size: 6, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '样品管理',
        secondTitle: '样品详情'
      },
      goodsInfo: {},
      rules: {
        name: [
          {
            required: true,
            message: '请输入样品名称',
            trigger: 'blur'
          },
          // {
          //   max: 100,
          //   message: '样品名称不能超过一百个字',
          //   trigger: 'blur'
          // }
        ],
        masterPic: [
          {
            required: true,
            message: '请上传主图图片',
            trigger: 'change'
          }
        ],
        freight: [
          {
            required: true,
            message: '请选择运费模板',
            trigger: 'change'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'change'
          }
        ],
        limitDays: [
          {
            required: true,
            message: '请输入限购天数',
            trigger: 'blur'
          }
        ],
        limitNum: [
          {
            required: true,
            message: '请输入限购数量',
            trigger: 'blur'
          }
        ],
      },
      attribute: [],
      key: [],
      skuList: [],
      gid: null,
      id: null,
      freightList: [],
      baseInfo: {
        status: null,
        name: '',
        masterPic: '',
        twig: null,
        freight: null,
        limitDays: null,
        limitNum: null,
        baseSales: null,
      },
      freightList: [],
      goodsList: [],

      productList: [], // 已选产品列表
      selectProductList: [],
      selectProductVisible: false,
      selectAll: false,
      selectedObj: {},
      productForm: {
        name: '',
        id: null
      },
      timeStemp: +new Date(),
      prdList: [],
      load: false
    };
  },
  computed: {},
  async mounted() {
    this.getFreightList();
    let query = this.$route.query;
    if (query && query.id) {
      this.id = query.id;
      this.getGoodDetail(query.id);
    }
  },
  methods: {
    // 获取样品信息
    getGoodDetail(id) {
      this.loading++;
      this.httpGet(this.$root.getSampleInfo, { id }).then(
        (res) => {
          this.loading--;
          let baseInfo = { ...this.baseInfo };
          for (let key in baseInfo) {
            baseInfo[key] = res.spu[key];
          }
          this.baseInfo = { ...baseInfo };
          this.baseInfo.limitDays = res.spu.limitDays || 0;
          this.baseInfo.limitNum = res.spu.limitNum || 0;
          this.skuList = res.skuList;
          this.prdList = res.prdList;
          this.key = this.getAttrName(res.skuList);
          this.attribute = this.getAttrs(res.skuList);
          this.id = res.spu.id;
          this.getPortraitSearchName(this.prdList, 1);
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 根据组件转换格式为接口需要格式
    getAttrs(skus) {
      let newSkus = [...skus];
      let skusFormat = newSkus.map((item) => {
        let obj = {};
        item.attrs.forEach((attr) => {
          obj[attr.keyName] = attr.value;
        });
        return {
          ...item,
          attribute: obj
        };
      });
      return skusFormat;
    },
    // 获取所有规格
    getAttrName(skus) {
      let newAttrs = [];
      skus.forEach((item) => {
        item.attrs.forEach((attr) => {
          if (newAttrs.indexOf(attr.keyName) < 0) {
            newAttrs.push(attr.keyName);
          }
        });
      });
      return newAttrs;
    },
    // 获取模板列表
    getFreightList() {
      this.loading++;
      this.httpGet(this.$root.getFreightList, {
        page: 1,
        size: 9999
      }).then(
        (res) => {
          this.loading--;
          this.freightList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },


    handleCurrentChangeProduct(page){
      this.currentPage = page;
      this.getGoodsList();
    },
    getGoodsList() {
      // this.loading++;
      this.httpGet(this.$root.getGoodsList, {
        page: this.currentPage,
        size: this.size,
        ...this.productForm,
        id: +this.productForm.id || null,
      }).then(
        (res) => {
          // this.loading--;
          this.productList = res.list;
          this.total = res.total;
          this.timeStemp = +new Date();
          let flag = true;
          res.list.forEach(item => {
            if(!this.selectedObj[item.id]) flag = false;
          });
          this.selectAll = res.list.length ? flag : false;
        },
        (res) => {
          // this.loading--;
          this.$message.error(res);
        }
      );
    },
    resetProduct(){
      this.productForm = {
        id: null,
        name: '',
      };
      this.getGoodsList();
    },
    getPortraitSearchName(checkList){
      this.loading++;
      return this.httpPost(this.$root.getPortraitSearchName, {
        id: checkList,
        way: 1
      }).then(
        (res) => {
          this.loading--;
          this.prdList = res.list;
          res.list.forEach(item => {
            this.selectedObj[item.id] = true;
          })
          this.selectProductList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    changeSelected(e, item){
      this.selectedObj[item.id] = e;
      if(e) this.selectProductList.push(item);
      if(!e){
        this.selectProductList = this.selectProductList.filter(product => {
          return product.id !== item.id;
        });
      };
      let flag = true;
      this.productList.forEach(product => {
        if(!this.selectedObj[product.id]) flag = false;
      });
      this.selectAll = flag;
    },
    handleChangeAll(e){
      if(e){
        this.productList.forEach(item => {
          if(!this.selectedObj[item.id]) this.selectProductList.push(item);
          this.selectedObj[item.id] = true;
        });
      } else {
        this.productList.forEach(item => {
          // this.selectProductList.push(item);
          this.selectedObj[item.id] = false;
        });
        this.selectProductList = this.selectProductList.filter(item => {
          return this.selectedObj[item.id];
        })
      }
    },
    async selectProductModal(){
      this.selectedObj = {};
      this.selectAll = false;
      this.currentPage = 1;
      this.selectProductList = [];
      // if(this.prdList.length && !this.load){
      //   await this.getPortraitSearchName(this.prdList, 1);
      // } else {
        this.selectProductList = [...this.prdList];
        this.prdList.forEach(product => {
          this.selectedObj[product.id] = true;
        })
      // };

      this.getGoodsList();
      this.selectProductVisible = true;
    },
    emptyProduct(){
      this.selectProductList = [];
      this.selectedObj = {};
    },
    addProduct(){
      this.selectProductVisible = false;
      // if(this.currentItem){
      //   this.currentItem.checkList = [...this.selectProductList];
      //   this.currentItem.load = true;
      // }
      this.prdList = [...this.selectProductList];
      this.load = true;
    },


    // 取消
    handleCancel() {
      this.$router.push({ name: 'sampleManage' });
    },
    getMasterImgList(index, val) {
      if (val === '') {
        // slideshow.splice(index, 1);
        this.baseInfo.masterPic = null;
      } else {
        this.baseInfo.masterPic = val;
      }
      this.$refs.form.clearValidate(['masterPic']);
    },
    // 获取规格值
    editAttr(val) {
      console.log(val, 123);
      let newSkus = val.map((item) => {
        let arr = [];
        for (let key in item.attribute) {
          arr.push({
            keyName: key,
            value: item.attribute[key]
          });
        }
        return {
          // sku: {
            price: +item.price,
            stock: +item.stock,
            pic: item.pic,
            id: item.id,
          // },
          attrs: arr
        };
      });
      this.skuList = newSkus;
    },
    getSales(val) {
      // this.baseInfo.linePrice = +val;
    },
    // getDetail(val) {
    //   this.baseInfoForm.details = [...val];
    // },
    // 下一步
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.skuList.length) {
            this.$message({
              message: '请选择样品规格',
              type: 'warning'
            });
            return;
          }
          // for (let spuKey in this.spu) {
          //   this.spu[spuKey] = this.baseInfo[spuKey];
          // }
          this.addGood();
        } else {
          this.$message({
            message: '请填写样品信息',
            type: 'warning'
          });
        }
      });
    },
    // 添加样品
    addGood() {
      // 请求数据
      let inputData = {
        spu: this.baseInfo,
        skuList: this.skuList,
        prdList: this.prdList.map(item => item.id) || [],
      };
      console.log(inputData.spu);
      inputData.spu.limitNum = +inputData.spu.limitNum || 0;
      inputData.spu.limitDays = +this.baseInfo.limitDays || 0;
      inputData.spu.baseSales = +this.baseInfo.baseSales || 0;
      // 是否为编辑样品
      let method = 'httpPost';
      if (this.id) {
        method = 'httpPut';
        inputData.spu.id = this.id;
      }
      this.loading++;
      this[method](
        this.id ? this.$root.updateSample : this.$root.addSample, // 添加样品 or 创建样品
        inputData
      ).then(
        (res) => {
          this.$message({
            message: this.id ? '样品修改成功' : '样品创建成功',
            type: 'success'
          });
          this.loading--;
          this.$router.push({
            name: 'sampleManage'
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addOption() {
      this.optionList.push({
        name: '',
        value: ''
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.good-info-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    // padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 0 20px 24px;
      border-radius: 2px;

      .group {
        background: white;
        padding: 10px 0;
        margin-bottom: 10px;
        .basic {
          height: 48px;
          line-height: 48px;
          font-size: 20px;
          text-indent: 20px;
          // margin-top: 20px;
          color: gray3;
          flex-x(flex-start);

          span {
            // color: red;
            color: gray6;
            margin-right: 3px;
          }
        }
        .add-goods-box{
          max-width: 620px;
          min-height: 40px;
          box-sizing: border-box;
          flex-x(flex-start);
          border: 1px solid #E8E8E8;
          padding: 0 6px;
          border-radius: 4px;
          white-space: nowrap;
          flex-wrap: wrap;
          .left{
            // width: 600px;
            // min-height: 120px;
            // border-radius: 5px;
            // border: 1px solid #E8E8E8;
            // padding: 6px 10px;
            width: 100%;
            box-sizing: border-box;
            flex-x(flex-start, flex-start);
            white-space: nowrap;
            flex-wrap: wrap;
            .item{
              height: 24px;
              min-width: 60px;
              padding:0 12px;
              border-radius: 2px;
              background: #EBEBEB;
              word(12px, #333);
              flex-x(center);
              margin: 3px 0;
              margin-right: 8px;
              // margin-bottom: 8px;
              position: relative;
              div{
                line-height: 16px;
                position: absolute;
                right: -6px;
                top: -6px;
                cursor: pointer;
              }
            }
          }
          .btn{
            height: 24px;
            margin: 3px 0;
            flex-x(center);
            word(14px, #5283FF);
            cursor: pointer;

          }
        }
      }

      .base-info {
        // margin-bottom: 10px;
        background: white;

        .good-form {
          padding: 20px 0 30px;

          .img-box {
            flex-x(flex-start);
          }
        }

        .base-info-form {
          margin-left: 90px;
        }

        .good-input {
          width: 620px;
        }

        .tip {
          font-size: 14px;
          color: gray6;
          margin-left: 16px;
        }

        .red {
          color: red;
        }

        .option-box {
          background: #F7F8FA;
          padding: 0 24px;
          border-radius: 2px;
          border: 1px solid #E8E8E8;
          // height: 32px;
          overflow: hidden;

          .option-item {
            flex-x(flex-start);
            height: 40px;

            &.option-head {
              height: 32px;
            }

            input {
              height: 32px;
              background: #fff;
              border: 1px solid #E8E8E8;
              box-sizing: border-box;
            }

            .cell1 {
              width: 330px;

              input {
                width: 310px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }

            .cell2 {
              input {
                width: 500px;
                padding: 0 10px;
                box-sizing: border-box;
              }
            }
          }

          .option-btn {
            width: 94px;
            height: 32px;
            border: 1px solid #E8E8E8;
            box-sizing: border-box;
            background: #fff;
            flex-x(center);
            font-size: 14px;
            border-radius: 2px;
            cursor: pointer;
            margin-top: 12px;
            margin-bottom: 16px;
          }
        }

        .row{
          flex-x(flex-start);
          .item{
            height: 66px;
            flex-x(flex-start);
            .label{
              width: 200px;
              margin-right: 36px;
              text-align: right;
            }
          }
        }
      }

      .good-specs-box {
        .good-specs {
          // padding: 20px;
          // border: 1px solid gray9;
          margin: 30px 70px 0 60px;
        }
      }

      .remarks {
        width: 100%;
        padding-left: 95px;
        box-sizing: border-box;

        .remarks-input {
          max-width: 600px;

          textarea {
            font-size: 14px;
            max-width: 600px;
          }
        }

        .good-detail {
          padding-left: 82px;
        }
      }

      .good-detail {
        padding-bottom: 50px;
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    height: 100px !important;
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
    padding-top: 20px;
    // padding-bottom: 48px;

    .btn-tip{
      position: absolute;
      word(14px, #5283FF);
      top: 15px;
    }

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }


  .select-product-box{
    .filter-box{
      flex-x(flex-start);
      .label{
        margin-right: 16px;
        margin-left: 12px;
      }
      .search{
        width: 65px;
        height: 36px;
        border-radius: 5px;
        background: #5283FF;
        border: 1px solid #5283FF;
        box-siing: border-box;
        word(14px, #fff);
        flex-x(center);
        cursor: pointer;
        margin-left: 24px;
      }
      .reset{
        width: 65px;
        height: 36px;
        border-radius: 5px;
        background: #fff;
        border: 1px solid #979797;
        box-siing: border-box;
        word(14px, #333);
        flex-x(center);
        cursor: pointer;
        margin-left: 12px;

      }
    }
    .product-list-box{
      flex-x();
      margin-top: 20px;
      margin-bottom: 20px;
      .list-left, .list-right{
        width: 550px;
        height: 480px;
        background: #F2F2F2;
        border: 1px solid #E8E8E8;
        .list-top{
          height: 32px;
          flex-x(flex-start);
          padding: 0 12px;
          box-sizing: border-box;
          border-bottom: 1px solid #E8E8E8;
          span{
            cursor: pointer;
          }
        }
        &.list-right{
          .list-top{
            width: 100%;
            flex-x();
          }
        }
        .product-list{
          flex-y(flex-start);
          padding: 0 12px;
          .item{
            width: 100%;
            height: 65px;
            flex-x(flex-start);
            border-bottom: 1px dashed #D1D1D1;
            .pic{
              width: 44px;
              height: 44px;
              border-radius: 2px;
              margin-left: 10px;
              margin-right: 5px;
            }
            .product-info{
              flex: 1;
              height: 36px;
              flex-y(space-between, flex-start);
            }
            .price{
              height: 36px;
              word(14px, #FF8D1A);
              flex-y(flex-end, flex-start);
            }
          }
        }
        .pagination{
          width: 100%;
          height: 36px;
          flex-x(flex-end);
          margin-top: 10px;
        }
      }
      .list-right{
        overflow-y: auto;
      }
    }
  }

}
</style>
